<template>
  <div id="app">
    <localization></localization>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import Localization from '@/localization'

export default {
  name: 'app',
  components: { Localization },
  computed: {
    ...mapState(['settings']),
    nextRoute() {
      return this.$route.query.redirect || '/'
    },
    currentRoute() {
      return this.$route.path
    },
  },
  mounted() {
    this.$store.commit('SET_PRIMARY_COLOR', { color: this.settings.primaryColor })
    this.$store.commit('SET_THEME', { theme: this.settings.theme })
  },
  created() {
    window.__jipinkGoogleMapsReady = () => this.onGooglePlacesLoad()
  },
  beforeDestroy() {
    delete window.__jipinkGoogleMapsReady
  },
  watch: {
    '$auth.isAuthenticated'(authenticated) {
      if (authenticated) {
        // this.$store.dispatch('GET_METADATA')
      }
    },
    '$store.state.settings.theme'(theme) {
      this.$store.commit('SET_THEME', { theme })
    },
    authorized(authorized) {
      if (authorized && this.currentRoute === '/auth/login') {
        this.$router.replace(this.nextRoute)
      }
    },
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
  metaInfo () {
    return {
      script: [
        {
          src: `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&libraries=places&loading=async&callback=__jipinkGoogleMapsReady`,
          async: true,
          defer: true,
        },
      ],
    }
  },
  methods: {
    async onGooglePlacesLoad () {
      const places = await window.google.maps.importLibrary('places')

      Vue.prototype.$geocoder = new window.google.maps.Geocoder()
      Vue.prototype.$autocomplete = {
        getPlacePredictions: async (request, handlePredictions) => {
          try {
            const { suggestions } = await places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
              input: request.input,
              includedRegionCodes: request.componentRestrictions && request.componentRestrictions.country,
              locationBias: request.bounds,
              region: 'ar',
            })

            const predictions = suggestions
              .map(suggestion => suggestion.placePrediction)
              .filter(Boolean)
              .map(prediction => ({
                place_id: prediction.placeId,
                placePrediction: prediction,
                description: prediction.text && prediction.text.text,
                structured_formatting: {
                  main_text: prediction.mainText ? prediction.mainText.text : prediction.text.text,
                  secondary_text: prediction.secondaryText ? prediction.secondaryText.text : '',
                },
              }))

            handlePredictions(predictions, predictions.length
              ? window.google.maps.places.PlacesServiceStatus.OK
              : window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS)
          } catch (error) {
            const status = window.google.maps.places.PlacesServiceStatus.UNKNOWN_ERROR
            // Google Places callbacks use (predictions, status), not Node's (error, result).
            // eslint-disable-next-line node/no-callback-literal
            handlePredictions([], status)
          }
        },
      }
    },
  },
}
</script>
